<template>
  <div class="multi-badge inline-block">
    <div
      v-bind="$attrs"
      class="items-center rounded-md px-1.5 py-0.5 font-medium select-none"
      :class="[getSizeClass(), color]"
    >
      <slot />
      <button
        v-if="removable"
        type="button"
        @click.stop.prevent="$emit('remove')"
        class="ml-0.5 inline-flex size-4 shrink-0 items-center justify-center rounded-full focus:outline-hidden"
      >
        <FontAwesomeIcon :icon="['fas', 'trash-can']" size="xs" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

defineEmits(["remove"])

defineOptions({
  inheritAttrs: false
})

type BadgeSize = "xs" | "sm" | "md" | "lg"

const props = defineProps({
  size: {
    type: String as () => BadgeSize,
    default: "md",
    validator: (value: string) => ["lg", "md", "sm", "xs"].includes(value)
  },
  removable: {
    type: Boolean,
    default: false
  },
  fileUrl: {
    type: String,
    default: null
  },
  color: {
    type: String,
    default: "primary",
    validator: (value: string) => {
      return [
        "primary",
        "primary-lighten-1",
        "secondary",
        "surface",
        "warning",
        "error",
        "success"
      ].includes(value)
    }
  }
})

function getSizeClass() {
  const textSize = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg"
  }

  return textSize[props.size]
}
</script>

<style scoped></style>
